import React, { useEffect } from "react";

interface SharedModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  width?: string;
  height?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  px?: string;
  py?: string;
  mobilePx?: string;
  mobilePy?: string;
  children: React.ReactNode;
}
// shared modal component should also accept the mobile width and height as props and also accept the px and py for mobile and desktop as props
export const SharedModal: React.FC<SharedModalProps> = ({
  isOpen,
  onRequestClose,
  width = "570px",
  height = "480px",
  mobileWidth = "375px",
  mobileHeight = "480px",
  px = "0px",
  py = "0px",
  mobilePx = "0px",
  mobilePy = "0px",
  children,
}) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Handle click outside modal
  const handleClickOutside = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onRequestClose();
    }
  };

  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onRequestClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onRequestClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-[4px]"
      onClick={handleClickOutside}
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-20 transition-opacity" />

      {/* Modal */}
      <div
        className={`relative w-[${mobileWidth}] h-[${mobileHeight}] md:w-[${width}] md:h-[${height}] px-[${mobilePx}] md:px-[${px}] py-[${mobilePy}] md:py-[${py}] border-none bg-white rounded-[24px] shadow-lg transform transition-all`}
      >
        {children}
      </div>
    </div>
  );
};
